import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=5654d318&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=ts&"
export * from "./JobList.vue?vue&type=script&lang=ts&"
import style0 from "./JobList.vue?vue&type=style&index=0&id=5654d318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654d318",
  null
  
)

export default component.exports